export enum MarkerSortingState {
  UNOPTIMIZED,
  OPTIMIZED,
  A_Z,
}
